import { render } from "./SideMenu.vue?vue&type=template&id=54e7f4ac"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/consultant/SideMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54e7f4ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54e7f4ac', __exports__)) {
    api.reload('54e7f4ac', __exports__)
  }
  
  module.hot.accept("./SideMenu.vue?vue&type=template&id=54e7f4ac", () => {
    api.rerender('54e7f4ac', render)
  })

}


export default __exports__